import type { Assessment } from "../types/assessment.js";
import type { ActingParty, PersonInvolvement } from "../types/involvement.js";
import { isInvolvementHeldBy } from "./isInvolvementHeldBy.js";
import { isInvolvementLive } from "./isInvolvementLive.js";

/**
 * Whether this party, acting for this organisation, is the approver named for
 * this assessment's owner's work.
 *
 * `approve` over the person, which `personActionsFromOwnInvolvements` answers,
 * says the party may approve. This says whose work: an approver's involvement
 * names the designated assessor it approves, and approves nobody else's
 * assessment of the person.
 */
export const isAssessmentApprover = (
  involvements: readonly Pick<
    PersonInvolvement,
    "kind" | "party" | "approvesUserId" | "endedAt" | "expiresAt"
  >[],
  party: Pick<ActingParty, "userId" | "organisationId">,
  assessment: Pick<Assessment, "ownerUserId">,
  now: Date = new Date(),
): boolean =>
  involvements.some(
    (involvement) =>
      involvement.kind === "approver" &&
      involvement.approvesUserId === assessment.ownerUserId &&
      isInvolvementLive(involvement, now) &&
      isInvolvementHeldBy(involvement, party),
  );
